/**
 * @file calling card
 * @author zhaomiaoyuan
 */
import React, {useState} from 'react';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';
import {useHistory} from 'react-router-dom';

import './index.less';
const CallingCardSelect = (props) => {
    const {
        data,
        rewrite,
        callbackChange,
        updateData
    } = props;
    const [phoneShow, setPhoneShow] = useState(false);
    const [phoneList, setPhoneList] = useState(data.phoneList);
    const history = useHistory();

    const clickPhoneList = () => {
        // setPhoneShow(!phoneShow);
        setPhoneShow(true);
    };
    const hidePhoneList = () => {
        setPhoneShow(false);
    };

    const pageRewrite = () => {
        history.push(history.location.pathname);
        updateData({phoneList: [], titleName: '', phoneName: ''});
        rewrite();
    };
    const changePhone = (val) => {
        callbackChange(val);
        setPhoneShow(false);
    };
    const renderPhoneSelect = () => {
        return phoneList.map(val => {
            return (
                <div className="phone-item" key={val.phone} onClick={() => changePhone(val)}>
                    {val.phone}{val.name ? `（${val.name}）` : ''}
                    {val.phone === data.phone ? <i className="choose"></i> : ''}
                </div>
            );
        });
    };
    return (
        <div onMouseLeave={hidePhoneList}>
            <ul className="calling-card">
                {phoneList.length > 1 && <li
                    className={phoneShow ? 'up-and-down rotate' : 'up-and-down'}
                    onClick={clickPhoneList}
                    onMouseEnter={clickPhoneList}
                >
                    <i></i>
                </li>}
                <li className="content-wrap">
                    <span>{data.phone + (data.phoneName ? `（${data.phoneName}）` : '')}</span>
                </li>
                {data.titleName && <li><span>{data.titleName}</span></li>}
            </ul>
            {phoneShow && <div className="phone-list-display">
                {renderPhoneSelect()}
            </div>}
            <p className="rewrite">
                不是该号码？
                <span onClick={pageRewrite}>
                    重新输入
                </span>
            </p>
        </div>
    );
};

CallingCardSelect.propTypes = {
    data: PropTypes.object,
    rewrite: PropTypes.func,
    callbackChange: PropTypes.func,
    updateData: PropTypes.func
};

export default withRouter(CallingCardSelect);
